import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Allocate } from "../Allocate";
import { Filter } from "../Filter";
import { Publish } from "../Publish";
import { IAllRequirements } from "../../../models/AllRequirements";
import { IModel2 } from "../sales/TableAll";
import { format } from "date-fns";
import { IReqFilter, EmptyFilter } from "../Filter";
import { Dialog } from "primereact/dialog";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Tag } from "primereact/tag";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { User } from "../../jvConnect/User";
import { Job_Type, Req_Term } from "../../../models/RequirementMast";

interface Iprops {
    toast: any
    permissions: IPermissionProps,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const TableSkill = (props: Iprops) => {
    const [tableAllData, setTableAllData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });
    const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
    const dt = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [allocation, setAllocation] = useState({ singleData: {}, open: false } as IModel2);
    const hideAllocationDialog = () => {
        setAllocation({ singleData: {}, open: false });
    };
    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean, rrreason: string | undefined, req_ID: number | undefined });
    const hideRRRDialog = () => {
        setRRR({ open: false, rrreason: "", req_ID: 0 });
    };

    useEffect(() => {
        loadTableData();
    }, [reqFilter, props.reload]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableAllData({ tableData: tableAllData.tableData, loading: true });
        const response = await Fetch("Requirement_MAST", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${4}`, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setTableAllData({ tableData: data, loading: false });
        } else setTableAllData({ tableData: tableAllData.tableData, loading: false });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Major Tech Allocation</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <div style={{ display: 'flex' }}>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: null } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'DodgerBlue', color: 'white' }}>All</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "UnAllocated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'skyblue', color: 'white' }}>UnAlloc</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Implementing_Partner" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '8rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>Imp. Partner</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Served" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'green', color: 'white' }}>Served</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Unserved" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'yellow', color: 'black' }}>UnServed</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Rejected" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'red', color: 'white' }}>Rejected</div>
                    <div onClick={() => setReqFilter((f) => { return { ...f, served_status: "Updated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>Updated</div>
                    {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
                </div>
            </span>
        </div>
    );

    const req_ID = (rowData: IAllRequirements) => {
        return (props.permissions.is_Create && !rowData.hold && (loginObj.id === 1346 || rowData.reqType_ID === 1) ?
            <span onClick={() => setAllocation({ singleData: rowData, open: true })} className="cursor-pointer text-cyan-700 underline">
                {rowData.req_ID}
            </span> : <span>{rowData.req_ID}</span>);
    };
    const req_Job_Title = (rowData: IAllRequirements) => {
        return rowData.rejected_Status === "Yes" ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
                setRRR({ open: true, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID })
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.req_EditedBy ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="warning" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };
    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const submission_id = (rowData: IAllRequirements) => {
        const countOfSubmissions = rowData.submission_id?.split(', ').length;
        const color = countOfSubmissions ? 'green' : rowData.recruiter ? 'yellow' : 'skyblue';
        return (<div style={{ background: color, minWidth: '70px', minHeight: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
            <span className="text-white">{countOfSubmissions}</span></div>);
    };
    const rowClass = (data: any) => {
        return {
            'bg-orange-100 font-semibold': data.reqType_ID === 1,
        };
    };

    const DateFormat = loginObj.date_Format
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={1} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableAllData.tableData} emptyMessage="No Requirements found."
                header={header} loading={tableAllData.loading}
                rowClassName={rowClass}

            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="req_ID" header="Req.ID" sortable body={req_ID} />
                <Column field="user_Name" sortable header="Sales Manager"
                    body={(r: IAllRequirements) => <User req={{
                        reqId: r.req_ID ?? '',
                        jobTitle: r.req_Job_Title ?? '',
                        postedDate: r.pDate ?? '',
                        userId: r.req_PostedBySalesManager ?? 0,
                        userName: r.user_Name ?? '',
                    }}
                    />} />
                <Column field="salesCompany" header="Sales Comp(Branch)" />
                <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} sortable />
                <Column field="req_Duration" header="Duration" />
                <Column field="location" header="Location" />
                <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                <Column field="req_CategoryName" header="Category" sortable />
                <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
                {/* <Column field="pDate" header="Date" body={pDate} /> */}
                <Column field="pDate" header="Date" body={(rowData: any) => safeFormatDate(rowData.pDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="recruiter" header="Recruiter" body={(rowData: any) => <span>{rowData?.recruiter?.split(",").map((el: string) => `${el.trim().split("-")[0]}-${el.trim().split("-")[1]}`).join(", ")}</span>} />
                 <Column field="hold" header="Status" body={(rowData: IAllRequirements) => rowData.hold ? "Hold" : "Unhold"} />
                <Column field="submission_id" header="Submittals" body={submission_id} />
            </DataTable>
            < Allocate roles={_roles} singleData={allocation.singleData} open={allocation.open} hideDialog={hideAllocationDialog} toast={props.toast} />
            {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={1} /> */}
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            <Dialog visible={rrr.open} style={{ width: '80vw' }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
                <JVSunEditor value={rrr.rrreason} />
            </Dialog>
        </>
    );
}
